import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { SMALL_MARGIN, colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableCell: {
      flex: 1,
      padding: `0 ${SMALL_MARGIN}px`,
    },
    learnerCell: {
      flex: 2,
      [theme.breakpoints.down('md')]: {
        flex: 3,
      },
    },
    learnerName: {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      [theme.breakpoints.down('sm')]: {
        fontWeight: 700,
      },
    },
    learnerEmail: {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      color: fade(colorsPalette.white, 0.33),
    },
    learnerRoleMobile: {
      fontSize: 14,
      fontWeight: 1.2,
      color: colorsPalette.gray,
      padding: '2px 0',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }),
);

export default useStyles;
